<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>

#app {
  min-height: 100%;
  height: 100%;
}

html, body {
    height: 100%;
    font-size: 1.3rem;
}

</style>
